export default __webpack_public_path__ + "static/media/Kawasaki2.ddcd453c.jpeg";